// extracted by mini-css-extract-plugin
export var auto = "_2f-1";
export var spinner = "_2f-0";